module.exports = __webpack_public_path__ + "img/img4.f55c4565.png";